import React from "react";
import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";
import INTERTELLOGO from "../../assets/Logos/INTERTELLOGO.png";
import NICBLogo from "../../assets/Logos/nicblogo.png";
import "./OrderHeader.css";

function OrderHeader() {
  return (
    <div>
      <div className="header">
        <Container fluid>
          <Row className="align-items-center">
            <Col xs={12} md={6}>
              <a href="https://intertelinc.com/" target="_blank" className="logo">
                <img src={INTERTELLOGO} alt="Intertel Logo" />
              </a>
            </Col>
            <Col xs={12} md={6} className="text-md-right">
              <div className="contact-info">
                <p className="phone-number">(800) 791-7776</p>
                <div className="font-strategic">Strategic Partnership Announced</div>
                <a href="https://intertelinc.com/nicb-welcomes-intertel-as-strategic-partner" target="_blank">
                  <img src={NICBLogo} alt="Intertel Logo" />
                </a>
              </div>
            </Col>
          </Row>
          <Row className="form-links">
            <Col>
              <a href="https://intertelinc.com/about" target="_blank">ABOUT</a>
            </Col>
           <Col>
              <a href="https://intertelinc.com/services" target="_blank">SERVICES</a>
            </Col>
           <Col>
              <a href="https://intertelinc.com/technology" target="_blank">TECHNOLOGIES</a>
            </Col>
           <Col>
              <a href="https://intertelinc.com/partnerships" target="_blank">PARTNERSHIPS</a>
            </Col>
           <Col>
              <a href="https://intertelinc.com/resources" target="_blank">RESOURCES</a>
            </Col>
           <Col>
              <a href="https://intertelinc.com/contact" target="_blank">CONTACT</a>
            </Col>
            <Col>
              <span className="request-form">Request Form</span>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default OrderHeader;
